import { render, staticRenderFns } from "./Dlrz.vue?vue&type=template&id=46e6c1de&scoped=true&"
import script from "./Dlrz.vue?vue&type=script&lang=js&"
export * from "./Dlrz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e6c1de",
  null
  
)

export default component.exports